/**
 * Gallery axis strategy registry.
 *
 * Maps axis types to their corresponding strategy implementations.
 */

import {type GalleryAxisStrategy} from './GalleryAxisStrategy';
import {IndexAxisStrategy} from './IndexAxisStrategy';
import {RunAxisStrategy} from './RunAxisStrategy';
import {StepAxisStrategy} from './StepAxisStrategy';

export type {GalleryAxisStrategy} from './GalleryAxisStrategy';
export {IndexAxisStrategy} from './IndexAxisStrategy';
export {RunAxisStrategy} from './RunAxisStrategy';
export {StepAxisStrategy} from './StepAxisStrategy';

/**
 * Registry of gallery axis strategies.
 * Maps axis type names to their strategy implementations.
 */
export const GALLERY_AXIS_STRATEGIES: Record<string, GalleryAxisStrategy> = {
  run: new RunAxisStrategy(),
  step: new StepAxisStrategy(),
  index: new IndexAxisStrategy(),
};

/**
 * Gets the strategy for a given axis type.
 * Falls back to 'run' if axis type is unknown.
 *
 * @param axis - The axis type ('run', 'step', or 'index')
 * @returns {GalleryAxisStrategy} The appropriate strategy instance
 */
export function getGalleryAxisStrategy(axis: string): GalleryAxisStrategy {
  return GALLERY_AXIS_STRATEGIES[axis] ?? GALLERY_AXIS_STRATEGIES.run;
}
